import { render, staticRenderFns } from "./newFeature.vue?vue&type=template&id=301907f9&scoped=true&"
import script from "./newFeature.vue?vue&type=script&lang=js&"
export * from "./newFeature.vue?vue&type=script&lang=js&"
import style0 from "./newFeature.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newFeature.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./newFeature.vue?vue&type=style&index=2&id=301907f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301907f9",
  null
  
)

export default component.exports